export default __webpack_public_path__ + "static/media/detail.fb27e299.svg";